import { render, staticRenderFns } from "./selectClassModel.vue?vue&type=template&id=7124f72d"
import script from "./selectClassModel.vue?vue&type=script&lang=js"
export * from "./selectClassModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports